module.exports = __webpack_public_path__ + "static/media/shortlisted-candidate.30429479.svg";